"use client";
import React, { ReactElement, useState } from "react";
import Image from "next/image";
import styles from "./Reviews.module.css";
import ReviewComponent from "../../molecules/Review";
const GreenStar = "/images/icons/green-star.svg";
import { getAverageReview } from "../../../utils/calculations";
import { Review } from "@/app/me/[slug]/Mentor/Mentor.schema";
import Coin from "./Coin";

export interface ReviewsProps {
  reviews: Review[];
}

const MAX_REVIEWS_TO_SHOW = 5;

const Reviews = ({ reviews }: ReviewsProps): ReactElement => {
  const [show_more, setShowMore] = useState(false);

  const toggleShowMore = () => setShowMore(!show_more);

  const orderReviews = (reviews_to_order: Review[]) => {
    return reviews_to_order
      .sort((a: Review, b: Review) => {
        const b_rating = (b.comment?.length || 0) + a.rating * 100;
        const a_rating = (a.comment?.length || 0) + a.rating * 100;
        if (a_rating > b_rating) {
          return -1;
        }
        if (a_rating === b_rating) {
          return 0;
        } else {
          return 1;
        }
      })
      .slice(
        0,
        show_more
          ? reviews_to_order.length
          : Math.min(MAX_REVIEWS_TO_SHOW, reviews_to_order.length)
      );
  };

  const average_review = getAverageReview(reviews);

  return (
    <div className={styles.container} id="reviews_container">
      <div className={styles.header}>
        <div className={styles.review_summary}>
          <h3 className={styles.average_review}>{average_review.toFixed(1)}</h3>
          <Coin />
        </div>
        <span className={styles.session_no}></span>
      </div>
      <div className={styles.reviews}>
        {reviews &&
          orderReviews(reviews).map((review, i) => (
            <ReviewComponent key={`review-${i}`} {...review} />
          ))}
      </div>
      {reviews.length > MAX_REVIEWS_TO_SHOW && (
        <button className={styles.show_more} onClick={toggleShowMore}>
          {!show_more ? "Read all reviews" : "Show less"}
        </button>
      )}
    </div>
  );
};

export default Reviews;
